import { MdDoneAll } from 'react-icons/md';
import { Heading, Icon, IconContainer } from '@nbirl/nbi-common-ui-libs';

import { EmptyResources } from '../../common/components';

export const EmptyPendingApproval = () => (
  <EmptyResources>
    <IconContainer variant="light">
      <Icon icon={<MdDoneAll className="text-primary-500" />} />
    </IconContainer>

    <Heading className="text-center text-gray-700">
      No documents pending approval
    </Heading>

    <p className="text-center">
      Currently there are no documents requiring your approval.
    </p>
  </EmptyResources>
);
